// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers';
import type { ClientApplication } from '../../client';
import type {
  PendingEdit,
  PendingEditData,
  PendingEditPatch,
  PendingEditQuery,
  PendingEditService,
} from './pending-edit.class';

export type { PendingEdit, PendingEditData, PendingEditPatch, PendingEditQuery };

export type PendingEditClientService = Pick<
  PendingEditService<Params<PendingEditQuery>>,
  (typeof pendingEditMethods)[number]
>;

export const pendingEditPath = 'api/pending-edit';

export const pendingEditMethods: Array<keyof PendingEditService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
  'approve',
  'reject',
];

export const pendingEditClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(pendingEditPath, connection.service(pendingEditPath), {
    methods: pendingEditMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [pendingEditPath]: PendingEditClientService;
  }
}
